import styled from 'styled-components';
import { math } from 'polished';
import PropTypes from 'prop-types';

const SiteBody = styled.main`
   min-height: ${({ theme, fixedHeader }) =>
      `calc(100vh - ${
         fixedHeader
            ? theme.sizes.siteFooterHeight
            : math(
                 `${theme.sizes.siteHeaderHeight} + ${
                    theme.sizes.siteFooterHeight
                 }`
              )
      });`};
   padding-top: ${({ theme, fixedHeader }) =>
      fixedHeader ? theme.sizes.siteHeaderHeight : '0'};
`;

SiteBody.propTypes = {
   fixedHeader: PropTypes.bool,
};

SiteBody.defaultProps = {
   fixedHeader: false,
};

export { SiteBody };
